<template>
  <div id="app" :class="[hide?'nominw':'']">
    <!-- <div style="width:48px;height:100vh;box-shadow: 0px 0px 8px 0px rgba(52,57,81,0.1000);z-index: 1000;" v-if="!hide"></div> -->
    <router-view v-if="isRouterAlive" />
    <!-- 【外呼】 新增对接线路商“融营”，首次拨打需验证手机号 -->
    <callValidPhone ref="callValidPhone" />
  </div>
</template>
<script>
import { getToken, getCookie } from '@/base/cookie'
import callValidPhone from '@/components/callValidPhone'
import { initIframe } from '@/utils/iframeUtils'

export default {
  name: 'App',
  components: {
    callValidPhone
  },
  data() {
    return {
      timerQuery: null,
      nowToken: undefined,
      isRouterAlive: true,
      hide: false
    }
  },
  // watch: {
  //   $route(to,from){
  //       if (this.$route.query.hide) {
  //         this.hide = true
  //       }
  //   }
  // },
  computed: {

  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
        // 解决首页一直reload
        this.nowToken = getToken()
      })
    },
    // 查询是否登录
    queryLogin() {
      if (getToken() !== this.nowToken && this.nowToken !== undefined && getToken() !== undefined) {
        this.reload()
      }
    }
  },
  beforeDestroy() {
    this.$bus.$off('vaildCallPhone')
  },

  mounted() {

    this.$router.onReady(() => {
      if (this.$route.query.hide) {
        this.hide = true
      }
    })


    initIframe()
    this.$bus.$on('vaildCallPhone', () => {
      this.$refs.callValidPhone && this.$refs.callValidPhone.init()
    })
    this.nowToken = getToken()
    this.timerQuery = setInterval(this.queryLogin, 1000) // 轮询查询登录状态
    if (
      process.env.NODE_ENV == 'pre' ||
      process.env.NODE_ENV == 'uat' ||
      process.env.NODE_ENV == 'production') {
      this.$store.dispatch('reqHelpDocUrl')
    }
    this.$store.dispatch('hasCrmEquity')
    // this.$store.dispatch('theCueQuotaStatistics')

    this.$store.dispatch('getRouters')
    this.$store.dispatch('getSelectArea')
    this.$store.dispatch('getIndustryInfo')

    console.log('打包时间：' + build_time)
  }
}

</script>

<style lang="scss">
#app {
  background-color: #fff;
  display: flex;
  // min-width: 1440px;
  // min-width: 1280px;
  // &.nominw{
  //   min-width: auto;
  // }
}
</style>
